enum SectionAttributeGroup {
  Tabs = "Tabs",
  Components = "Components",
  Tables = "Tables",
  Layouts = "Layouts",
}
export default SectionAttributeGroup;
